import { render, staticRenderFns } from "./AddUserModal.vue?vue&type=template&id=bc72a854&scoped=true&"
import script from "./AddUserModal.vue?vue&type=script&lang=ts&"
export * from "./AddUserModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddUserModal.vue?vue&type=style&index=0&id=bc72a854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc72a854",
  null
  
)

export default component.exports